<template>
  <div class="m-h-container" :class="headerStyle == 'w' ? 'm-h-container-w' : 'm-h-container-t' ">
    <div class="m-h-box">
      <div class="m-h-logo-box">
        <img src="@/assets/img/logo.png" alt>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "menuItem",
  computed: {
    headerStyle() {
      return this.$store.state.headerStyle;
    }
  }
};
</script>

<style lang="less" scoped>
.m-h-container {
  position: fixed;
  top: 0;
  z-index: 1000;
  width: 100%;
}
.m-h-container-w {
  background: #f7f7f7;
}
.m-h-container-t {
  background: rgba(0, 0, 0, 0.3);
}
.m-h-box {
  height: 60px;
  max-width: @baseW;
  margin: auto;
  .m-h-logo-box {
    display: inline-block;
    height: 100%;
    img {
      height: 100%;
    }
  }
}
// 超小屏响应
@media (max-width: 768px) {
  .m-h-container-w {
    background: rgba(0, 0, 0, 0.3);
  }
  .m-h-logo-box {
    float: right;
  }
}
</style>
